import _ from 'lodash';
import { INCIDENTS_MODEL, INCIDENTS_TABLE_MODEL } from '../incidents.model';
import ServicesCell from './cells/ServicesCell';
import RepositoriesCell from './cells/RepositoriesCell';
import DateCell from './cells/DateCell';
import TeamsCell from './cells/TeamsCell';
import IncidentCell from './cells/IncidentCell';
import StatusCell from './cells/StatusCell';
import { SourceCell } from './cells/SourceCell';

const useRows = ({ incidents }) => {
  const data = _.get(incidents, 'items', []);
  const rows = data.map(incident => {
    const status = _.get(incident, INCIDENTS_MODEL.STATUS);
    const source = _.get(incident, INCIDENTS_MODEL.SOURCE);
    const issuedAt = _.get(incident, INCIDENTS_MODEL.ISSUED_AT);
    const startedAt = _.get(incident, INCIDENTS_MODEL.STARTED_AT);
    const endedAt = _.get(incident, INCIDENTS_MODEL.ENDED_AT);
    const services = _.get(incident, INCIDENTS_MODEL.SERVICES) || [];
    const repositories = _.get(incident, INCIDENTS_MODEL.REPOSITORIES) || [];
    const teams = _.get(incident, INCIDENTS_MODEL.TEAMS) || [];

    return {
      ...incident,
      [INCIDENTS_TABLE_MODEL.INCIDENT_CELL]: (
        <IncidentCell incident={incident} />
      ),
      [INCIDENTS_TABLE_MODEL.STATUS_CELL]: <StatusCell status={status} />,
      [INCIDENTS_TABLE_MODEL.SOURCE_CELL]: <SourceCell source={source} />,
      [INCIDENTS_TABLE_MODEL.ISSUED_AT_CELL]: <DateCell date={issuedAt} />,
      [INCIDENTS_TABLE_MODEL.STARTED_AT_CELL]: <DateCell date={startedAt} />,
      [INCIDENTS_TABLE_MODEL.ENDED_AT_CELL]: <DateCell date={endedAt} />,
      [INCIDENTS_TABLE_MODEL.REPOSITORIES_CELL]: (
        <RepositoriesCell repositories={repositories} />
      ),
      [INCIDENTS_TABLE_MODEL.SERVICES_CELL]: (
        <ServicesCell services={services} />
      ),
      [INCIDENTS_TABLE_MODEL.TEAMS_CELL]: <TeamsCell teams={teams} />
    };
  });

  return rows;
};

export default useRows;
